webpackJsonp([169246006831466],{

/***/ 461:
/***/ (function(module, exports) {

	module.exports = {
		"data": {
			"postBySlug": {
				"html": "",
				"frontmatter": {
					"title": "First DMGT Doc"
				},
				"fields": {
					"slug": "/first-dmgt-doc"
				}
			}
		},
		"pathContext": {
			"slug": "/first-dmgt-doc"
		}
	};

/***/ })

});


// WEBPACK FOOTER //
// path---first-dmgt-doc-8a95b28a1b6ae86046ec.js